import { useMemo } from "react";
import { useGetMarketSize } from "../../../../../hooks/useGetMarketSize";
import { useCompetitorCustomerCounts } from "./useCompetitorCustomerCounts";

export const useGetCompetitorMarketPresence = () => {
  const marketData = useGetMarketSize();
  const { loading, competitorTam, competitorSam, competitorSom } =
    useCompetitorCustomerCounts();
  const tam = useMemo(() => {
    return {
      ...marketData.tam,
      currentCustomers: competitorTam,
    };
  }, [competitorTam, marketData.tam]);

  const sam = useMemo(() => {
    return {
      ...marketData.sam,
      currentCustomers: competitorSam,
    };
  }, [competitorSam, marketData.sam]);

  const som = useMemo(() => {
    return {
      ...marketData.som,
      currentCustomers: competitorSom,
    };
  }, [competitorSom, marketData.som]);

  return {
    tam,
    sam,
    som,
    isLoading: marketData.isLoading || loading,
  };
};
